$("input#your-name").on({
  keydown: function(e) {
    if (e.which === 32)
      return false;
  },
  change: function() {
    this.value = this.value.replace(/\s/g, "");
  }
});
$(document).ready(function(){
	var initial = 0;
    $('.spb-productoptionbackground').bind('keyup', function() {
    if(initial == 1){
        $(this).val(initialUpper($(this).val()));
    }
    var newtext = $(this).val(); 
            newctext = newtext.replace(/[^abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZÀàÇÊËçêëáÁãÃàÀâÂçÇéÉêÊíÍóÓõÕòÒôÔúÚùÙûÛäÄöÖüÜßßñÑèÈëËïÏîÎœŒ]/g, "");
     
    $(this).val(newctext);
            ctext = $(".spb-productoptionbackground").val();
        $(this).val(newctext);
        newctext = ctext;
        $("#showtext").html(ctext);
        $("#leftnum").html(13-$(this).val().length);
    
    
            var lastSpecialJson = {'à':'a','À':'A','â':'a','Â':'A','ç':'c','Ç':'C','é':'e','É':'E','ê':'e','Ê':'E','è':'e','È':'E','ë':'e','Ë':'E','ï':'i','Ï':'I','î':'i','Î':'I','ô':'o','Ô':'O','ù':'u','Ù':'U','û':'u','Û':'U','œ':'oe','Œ':'OE','á':'a','Á':'A','ã':'a','Ã':'A','í':'i','Í':'I','ó':'o','Ó':'O','õ':'o','Õ':'O','ò':'o','Ò':'O','ú':'u','Ú':'U','ä':'a','Ä':'A','ü':'u','Ü':'U','ß':'ss','ß':'ss','ñ':'n','Ñ':'N','ö':'o','Ö':'O'};
                var showtextval = $("#showtext").html();
        if(showtextval.length > 1){
            var _showtextval = showtextval.charAt(showtextval.length-1);
            if(lastSpecialJson[_showtextval] != undefined){
                showtextval = showtextval.substr(0,showtextval.length-1) + lastSpecialJson[_showtextval];
                $("#showtext").html(showtextval);
            }
        }
    

            var specialJson = {'á':'a','Á':'A','ã':'a','Ã':'A','í':'i','Í':'I','ó':'o','Ó':'O','õ':'o','Õ':'O','ò':'o','Ò':'O','ú':'u','Ú':'U','ä':'a','Ä':'A','ü':'u','Ü':'U','ß':'ss','ß':'ss','ñ':'n','Ñ':'N','ö':'o','Ö':'O'};
            var showtextval = $("#showtext").html();
    var newshowtextval = '';
    for(var i=0;i<showtextval.length;i++){
        if(specialJson[showtextval.charAt(i)] == undefined){             newshowtextval += showtextval.charAt(i);
        }else{
            newshowtextval += specialJson[showtextval.charAt(i)];
        }
    }
    $("#showtext").html(newshowtextval);
    
            var fontArr = {'a':'1','b':'2','c':'3','d':'4','e':'5','f':'6','g':'7','h':'8','i':'9','j':'0','k':'!','l':'@','m':'#','n':'$','o':'%','p':'^','q':'&','r':'*','s':'(','t':')','u':'-','v':'+','w':'[','x':']','y':'\\','z':';'};
        var showtextval = $("#showtext").html();
        if(showtextval.length > 1){
            var _showtextval = showtextval.charAt(showtextval.length-1);
            if(lastSpecialJson[showtextval.charAt(showtextval.length-1)] != undefined){
                                _showtextval = lastSpecialJson[showtextval.charAt(showtextval.length-1)];
            }
            if(typeof fontArr[_showtextval] != 'undefined'){                 
              showtextval = showtextval.substr(0,showtextval.length-1) + fontArr[_showtextval];
              //$("#showtext").html(showtextval);
            }
        }
    });
});

$('.product-form__item .color').change(function(){
  var color = $(this).val();
  if(color == 'Rose Gold'){
  	color = '#b76e79';
  }
  $('#showtext').css('color',color);
});
